import type { ResolvedTheme } from '@/types/ui';
import { resolveTheme } from '@/utils/theme';

export function useResolvedTheme(): ResolvedTheme {
  return resolveTheme();
}

export function useThemeEffect(): void {
  document.documentElement.setAttribute('data-theme', resolveTheme());
}
